<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast de alerta -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="mb-4">
        <h3>Registrar Salida Manual de Inventario</h3>
      </div>

      <!-- Formulario -->
      <div class="row g-4">
        <div class="col-md-4">
          <label class="form-label">Producto</label>
          <input v-model="busquedaProducto" type="text" class="form-control mb-1" placeholder="Buscar producto..." />
          <select v-model="nuevaSalida.IdProductoHotel" class="form-select">
            <option value="" disabled selected>Selecciona un producto</option>
            <option v-for="prod in productosFiltrados" :key="prod.IdProductoHotel" :value="prod.IdProductoHotel">
              {{ prod.NombreProducto }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label">Cantidad</label>
          <input v-model.number="nuevaSalida.Cantidad" type="number" min="1" class="form-control" />
        </div>
        <div class="col-md-2">
          <label class="form-label">Origen</label>
          <select v-model="nuevaSalida.Origen" class="form-select">
            <option value="" disabled selected>Selecciona origen</option>
            <option value="0">Lavandería</option>
            <option value="1">Recepción</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Motivo</label>
          <input v-model="nuevaSalida.Motivo" type="text" class="form-control" placeholder="Opcional" maxlength="2500" />
        </div>
      </div>

      <div class="text-end mt-3">
        <button class="btn btn-primary" @click="guardarSalida">Registrar Salida</button>
      </div>

      <!-- Tabla Salidas -->
      <div class="table-responsive mt-5">
        <h5>Historial de Salidas</h5>
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Fecha</th>
              <th>Producto</th>
              <th>Cantidad</th>
              <th>Origen</th>
              <th>Motivo</th>
              <th>Empleado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="salidas.length === 0">
              <td colspan="6">No hay salidas registradas.</td>
            </tr>
            <tr v-for="salida in salidas" :key="salida.IdSalidasInventariosHotel">
              <td>{{ salida.FechaSalida }}</td>
              <td>{{ salida.producto?.NombreProducto }}</td>
              <td>{{ salida.Cantidad }}</td>
              <td>
                <span v-if="salida.Origen === 0">Lavandería</span>
                <span v-else-if="salida.Origen === 1">Recepción</span>
                <span v-else>Desconocido</span>
              </td>
              <td>{{ salida.Motivo }}</td>
              <td>{{ salida.empleado?.Nombres }} {{ salida.empleado?.Apellidos }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";
import store from "@/store";

export default {
  name: "SalidasInventariosHotel",
  data() {
    return {
      productos: [],
      salidas: [],
      busquedaProducto: "",
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevaSalida: {
        IdProductoHotel: "",
        Cantidad: "",
        Origen: "",
        Motivo: ""
      }
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
    empleadoId() {
      return store.getters.getUser?.IdEmpleado || null;
    },
    productosFiltrados() {
      const q = this.busquedaProducto.trim().toLowerCase();
      if (!q) return this.productos;
      return this.productos.filter(p => (p.NombreProducto || "").toLowerCase().includes(q));
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerProductos() {
      try {
        const { data } = await axios.get(`${API_URL}/inventario-general-hotel`);
        this.productos = data;
      } catch (error) {
        console.error(error);
      }
    },
    async obtenerSalidas() {
      try {
        const { data } = await axios.get(`${API_URL}/salidas-inventarios-hotel`);
        this.salidas = data;
      } catch (error) {
        console.error(error);
      }
    },
    async guardarSalida() {
      const { IdProductoHotel, Cantidad, Origen, Motivo } = this.nuevaSalida;
      if (!IdProductoHotel || !Cantidad || Origen === "") {
        this.mostrarAlerta("Los campos obligatorios son Producto, Cantidad y Origen", "danger");
        return;
      }
      try {
        const payload = {
          IdProductoHotel,
          Cantidad,
          Origen,
          Motivo,
          IdEmpleado: this.empleadoId
        };
        await axios.post(`${API_URL}/salidas-inventarios-hotel`, payload);
        this.mostrarAlerta("Salida registrada", "success");
        this.nuevaSalida = { IdProductoHotel: "", Cantidad: "", Origen: "", Motivo: "" };
        this.obtenerSalidas();
        this.obtenerProductos();
      } catch (error) {
        console.error(error);
        const msg = error.response?.data?.message || "Error al registrar salida.";
        this.mostrarAlerta(msg, "danger");
      }
    }
  },
  mounted() {
    this.obtenerProductos();
    this.obtenerSalidas();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 450px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
